export default {
  change_to_community: "切換社區",
  entry: "詞條",
  home: "首頁",
  managers: "管理員",
  share: "分享",
  wiki_post: "WIKI投稿",
  talks: "社區討論",
  wiki_notice: "WIKI公告",
  search_within_the_wiki: "WIKI內搜索",
  calendar: "活動日歷",
  prev_week: "上一周",
  next_week: "下一周",
  prev_month: "上一月",
  next_month: "下一月",
  weeks: {
    mon: "一",
    tue: "二",
    wed: "三",
    thu: "四",
    fri: "五",
    sat: "六",
    sun: "七"
  },
  time_left: "剩余時間：",
  time_left2: "<span>{day}</span>天<span>{hours}</span>小時<span>{minutes}</span>分<span>{seconds}</span>秒",
  toggle_month: "月歷展示",
  toggle_week: "周歷展示",
  year: "年",
  mouth: "月",
  calendar_toggle1: "收起",
  calendar_toggle2: "展開",
  calendar_end: "已結束",
  official_notice: "官方公告",
  entry_update: "詞條更新",
  update: "更新",
  community: "玩家社區",
  community2: "社區",
  say_something: "說點什麽吧",
  send: "發布",
  all: "全部",
  posts: "帖子",
  strategy: "攻略",
  question: "問答",
  notices: "公告",
  entrys: "詞條",
  views: "閱讀數",
  edit: "編輯",
  history_record: "歷史記錄",
  favorite: "收藏",
  report: "舉報",
  created_on: "創建於",
  nothing_more: "沒有更多數據了",
  comments: "評論",
  comment: "評論",
  follow: "關註",
  followed: "已關註",
  fans: "粉絲",
  favorites: "收藏",
  back: "返回",
  nosign: "暫無簽名",
  check_in_details: "查看詳情",
  reply: "回復",
  entrys2: "個詞條",
  hot_entry: "熱門詞條",
  more: "更多",
  post_details: "帖子詳情",
  roll_back_to_the_version: "回滾到此版本",
  last_update: "最近更新",
  modified_to_version: "修改了{version}版本",
  friendly_link: "友情連結",
  cyct: "常用詞條",
  gltj: "攻略推薦",
  notice_tags: {
    tag1: "情報",
    tag2: "活動",
    tag3: "更新"
  },
  login_to_post: "登入後才能發帖哦"
};
